import React, { FC } from 'react';
import { TextV2 } from 'components/TextV2/TextV2';
import { useTranslation } from 'react-i18next';
import { translationKeyMap } from './BYOPricingUtils';
import { BooleanFilter } from 'utils/TypeUtils';
import { useSubscriptionsToggleOrder } from 'hooks/useSubscriptionsToggleOrder';

interface ISystemPreviewPriceDisplayProps {
  upfrontPrice: number;
  subscriptionHardwareMonthlyPrice: number;
}

export const SystemPreviewDrawerPricing: FC<ISystemPreviewPriceDisplayProps> = ({
  upfrontPrice,
  subscriptionHardwareMonthlyPrice,
}) => {
  const { t } = useTranslation();
  const { isMonthlyFirst: showMonthlyPriceFirst } = useSubscriptionsToggleOrder();

  if (BooleanFilter(subscriptionHardwareMonthlyPrice)) {
    return (
      <>
        {showMonthlyPriceFirst ? (
          <>
            <TextV2
              variant="body-medium"
              value={t(translationKeyMap.MONTHLY.primary, { price: subscriptionHardwareMonthlyPrice })}
            />
            <TextV2
              variant="body-small"
              value={t(translationKeyMap.UPFRONT.secondary, { price: upfrontPrice })}
            />
          </>
        ) : (
          <>
            <TextV2
              variant="body-medium"
              value={t(translationKeyMap.UPFRONT.primary, { price: upfrontPrice })}
            />
            <TextV2
              variant="body-small"
              value={t(translationKeyMap.MONTHLY.secondary, { price: subscriptionHardwareMonthlyPrice })}
            />
          </>
        )}
      </>
    );
  }

  return (
    <>
      <TextV2 variant="body-medium" value={t(translationKeyMap.UPFRONT.primary, { price: upfrontPrice })} />
    </>
  );
};
